exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4.event-module-header[data-v-ab7317f6]{display:inline-block;margin-right:1em}.tutor-item+.tutor-item[data-v-ab7317f6]:before{content:\", \"}.event-module-checkbox[data-v-ab7317f6]{margin-right:7px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ab7317f6","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ModuleDisplay.vue
// module id = 205
// module chunks = 0